import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import App from './App';
import AuthProvider from 'context/Auth.context';
import CandidateProvider from 'context/Candidate.context';
import StudentProvider from 'context/Student.context';
import './index.css';

ReactDOM.render(
	<React.StrictMode>
		<AuthProvider>
			<CandidateProvider>
				<StudentProvider>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</StudentProvider>
			</CandidateProvider>
		</AuthProvider>
	</React.StrictMode>,
	document.getElementById('root')
);
